import GLOBAL from '../store/actions/global'

const LegacyMCM = {
  install(Vue) {
    window.addEventListener('message', (event) => {
      if (!event.data.route) return
      ForkableVue.navigate(event.data.route)
    }, false)

    Vue.prototype.navigate = function navigate(route) {
      this.$store.dispatch(GLOBAL.NAVIGATE_FROM_EXT, route)
      this.$router.push(route)
    }
  },
}

export default LegacyMCM
